var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"m-b"},[_c('label',{staticClass:"form-check-label lh-34"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkedValue},on:{"change":_vm.search}}),_vm._v("\n            Nur Pressebilder anzeigen\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }